export default {
  getTariffCode: (state) => state.tariffCode,
};
